import { useCallback, useState } from "react";
import { getCurrentDate } from "../../../../Common/helper/helpar";

const getDefaultFilters = () => ({
  fromDate: getCurrentDate(),
  toDate: getCurrentDate(),
  ward: "",
});

const useDashboardFilters = (initialFilters) => {
  const defaults = { ...getDefaultFilters(), ...initialFilters };
  const [filters, setFilters] = useState(defaults);
  const [appliedFilters, setAppliedFilters] = useState(defaults);

  const handleFilterChange = useCallback((key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  }, []);

  const handleSearch = useCallback(() => {
    setAppliedFilters({ ...filters });
  }, [filters]);

  return {
    filters,
    appliedFilters,
    handleFilterChange,
    handleSearch,
  };
};

export default useDashboardFilters;
